/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable */
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import FocusTrap from 'focus-trap-react';
import { isEmpty, uniqueId } from 'lodash';
import { ButtonContainer, ButtonsGroups, DesktopButtonContainer } from 'ui-kit/old/styles/button.style';
import {
  BackgroundModal,
  ModalBody,
  CloseWindow,
  WrapperModal,
  CloseWindowTablet,
  CloseRetailerWrapper,
  WrapperContainer,
  CloseWindowContainer,
} from '../modal.style';
import { ContentModal } from './attention.style';
import { Title } from 'ui-kit/old/styles/content.style';
import CloseModalIcon from 'assets/icons/old//close-modal.svg';

const AttentionModal = ({
  typeContent = 'text',
  bigModal = false,
  viewComponent,
  Component,
  header,
  buttons,
  type,
  showModal,
  isShowModal,
  profileButton,
  componentProps,
  id,
  profile,
  shouldRedirect,
  isAgencies = false,
  containModal = '',
  setLockStatusRetailers,
  clearState = () => {},
  openModal,
  isPopUpWithCross,
}) => {
  const refTitle = useRef(null);
  const refModal = useRef(null);
  const history = useHistory();
  const ID_MENU = 'dashboardID';
  const [activeTrap, setActiveTrap] = useState(false);

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      isShowModal(false);
    }
  }, []);

  useEffect(() => {
    setActiveTrap(true);
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const handleClick = () => {
    clearState && clearState();
    setActiveTrap(false);
    setLockStatusRetailers && setLockStatusRetailers(true);
    document.getElementById(ID_MENU)?.focus();
  };

  const closeModal = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      isShowModal(false);
      e.preventDefault();
    }
  };

  const children = (
    <WrapperModal refModal={refModal} type={type}>
      <WrapperContainer type={type}>
        {type === 'addRetailerInfo' ? (
          <CloseWindowContainer
            tabIndex={-1}
            isAgencies={isAgencies}
            headerType="close"
            type={type}
            scrollY={componentProps && componentProps.scrollY ? componentProps.scrollY : 0}
          >
            <CloseRetailerWrapper
              onClick={() => {
                shouldRedirect && history.push(shouldRedirect);
                isShowModal(false);
                openModal && openModal(true);
                setActiveTrap(false);
                handleClick();
              }}
            >
              <img src={CloseModalIcon} alt={`close ${uniqueId()}`} />
            </CloseRetailerWrapper>
          </CloseWindowContainer>
        ) : (
          <CloseWindow
            isPopUpWithCross={isPopUpWithCross}
            onClick={() => {
              shouldRedirect && history.push(shouldRedirect);
              openModal && openModal(true);
              isShowModal(false);
              setActiveTrap(false);
              handleClick();
            }}
            id="closeWindowPii"
            headerType="close"
            type={type}
            scrollY={componentProps && componentProps.scrollY ? componentProps.scrollY : 0}
          >
            <img src={CloseModalIcon} alt={`close${uniqueId()}`} />
          </CloseWindow>
        )}
        <ModalBody type={type} scrollY={componentProps && componentProps.scrollY ? componentProps.scrollY : 0}>
          <CloseWindowTablet
            onClick={() => {
              shouldRedirect && history.push(shouldRedirect);
              openModal && openModal(true);
              isShowModal(false);
              setActiveTrap(false);
              handleClick();
            }}
            headerType="close"
            type={type}
            scrollY={componentProps && componentProps.scrollY ? componentProps.scrollY : 0}
          >
            <img src={CloseModalIcon} alt={`close${uniqueId()}`} />
          </CloseWindowTablet>
          {!isAgencies && (
            <Title type="modal" ref={refTitle} validValue="retailer">
              {header}
            </Title>
          )}
          {viewComponent && typeContent === 'text' ? (
            <ContentModal containModal={containModal} type={type} bigModal={bigModal}>
              {viewComponent}
            </ContentModal>
          ) : (
            ''
          )}
          {!viewComponent && typeContent === 'component' && <Component {...componentProps} />}
          {type === 'addRetailerInfo' ? (
            <DesktopButtonContainer>
              <ButtonsGroups profile={profile} profileButton={profileButton} type={type}>
                {buttons}
              </ButtonsGroups>
            </DesktopButtonContainer>
          ) : (
            <ButtonsGroups profile={profile} profileButton={profileButton} type={type}>
              {buttons}
            </ButtonsGroups>
          )}
          {type === 'addRetailerInfo' && <ButtonContainer isMob>{buttons}</ButtonContainer>}
          {type === 'popupAgencies' && <ButtonContainer type={type}>{buttons}</ButtonContainer>}
        </ModalBody>
      </WrapperContainer>
    </WrapperModal>
  );

  if (!showModal) {
    return (
      <BackgroundModal id={id} type={type}>
        {type !== 'popupMap' ? (
          <FocusTrap
            focusTrapOptions={{
              onDeactivate: handleClick,
            }}
          >
            {children}
          </FocusTrap>
        ) : (
          children
        )}
      </BackgroundModal>
    );
  }
  return null;
};

export default AttentionModal;
